module.exports = __webpack_public_path__ + "static/img/齿数的求法.3f7dc953.jpg";